import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdHistory } from "react-icons/md";
import ProductCard from "../components/Common/ProductCard";
import WalmartProductCard from "../components/Common/WalmartProductCard";
import instance from "../redux/actions/AxiosInstance/authenticated";

function History() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  const fetchHistory = async (currentPage = 1) => {
    try {
      setLoading(true);
      const response = await instance.post(
        `/history?limit=8&page=${currentPage}`
      );
      const items = response?.data?.data || [];
      const total = response?.data?.total || 0;

      setTotalItems(total);

      if (currentPage === 1) {
        setHistory(items);
      } else {
        setHistory((prev) => [...prev, ...items]);
      }

      setHasMore(items.length === 8);
    } catch (error) {
      console.error("Error fetching history:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory(1);
  }, []);

  const getProductKey = (data) =>
    data?.platform === "walmart" || data?.product_id
      ? data.product_id
      : data.asin;

  const handleCardClick = (asin) => {
    navigate(`/product?asin=${asin}`);
  };

  const handleWalmartClick = (productId) => {
    if (!productId) return;
    navigate(`/walmart-product?product_id=${productId}`);
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchHistory(nextPage);
  };

  console.log("history", history);
  return (
    <div className="bg-primary-bg min-h-screen">
      <div className="title border-b-2 border-b-border w-full md:p-[21.5px] p-3 text-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <MdHistory className="text-primary text-2xl" />
          <p className="text-white font-bold text-xl">History</p>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center min-h-[80vh] text-white">
          <div className="text-center text-primary mt-6">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      ) : (
        <div className="p-4 md:p-6">
          {history.length === 0 ? (
            <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
              <MdHistory className="text-gray-600 text-6xl mb-4" />
              <h3 className="text-gray-400 text-xl font-semibold mb-2">
                No History Yet
              </h3>
              <p className="text-gray-500 text-sm">
                Your product search history will appear here
              </p>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
                {history.map((item) => {
                  const data = item.data || {};
                  const isWalmart =
                    data.platform === "walmart" || (!!data.product_id && !data.asin);
                  const key = getProductKey(data) || item.id || item.createdAt;

                  if (isWalmart) {
                    return (
                      <WalmartProductCard
                        key={key}
                        product={data}
                        createdAt={item.createdAt}
                        onClick={() => handleWalmartClick(data.product_id)}
                      />
                    );
                  }

                  return (
                    <ProductCard
                      key={key}
                      product={data}
                      onClick={() => handleCardClick(data.asin)}
                      showActions={false}
                      createdAt={item.createdAt}
                    />
                  );
                })}
              </div>

              {hasMore && (
                <div className="flex justify-center mt-8">
                  <button
                    onClick={handleLoadMore}
                    disabled={loading}
                    className="bg-primary/10 text-primary border border-primary font-semibold py-2 px-8 rounded-lg hover:bg-primary hover:text-white transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? "Loading..." : "Load More"}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default History;
